
import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { Box } from '@piconetworks/ui'
import Form from '@piconetworks/pkg-form'
import style from '../Pagination.module.scss'

const PaginationMobile = (props) => {
    const { page, pages, changePage } = props
    const activePage = page + 1


    // creates dropdown options according to the contact list pages count to fill dropdown options
    const pageDropdownOptions = Array.from({ length: pages }, (v, k) => k + 1).map((item) => ({ value: item, label: `Page ${item}` }))
    return (
        <Box.Flexbox.Child className={cx(style.child, style.dropdown, style.pageCount)}>
            <Form.Dropdown
                name="page_count"
                options={pageDropdownOptions}
                menuPlacement="top"
                input={{
                    onChange: (item) => changePage(item),
                    onBlur: (e) => console.log(e),
                    value: activePage
                }}
                meta={{
                    error: null
                }}
            />
        </Box.Flexbox.Child>
    )
}

PaginationMobile.propTypes = {
    changePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired
}

export default PaginationMobile
